import { useState } from 'react';

const faqData = [
  {
    q: '五一黑料网的内容来源是什么？',
    a: '五一黑料网汇集全网黑料吃瓜内容，覆盖微博、抖音、小红书、豆瓣等多个主流社交平台。我们实时追踪各大平台的热门爆料、内幕事件和吃瓜动态，由专业编辑团队筛选整理，确保内容真实可靠、更新及时。',
  },
  {
    q: '每天更新多少条黑料内容？',
    a: '五一黑料网每日更新超过100条最新爆料和热点瓜内容。我们的编辑团队7×24小时不间断追踪全网动态，第一时间呈现瓜田爆料、黑料内幕和吃瓜事件合集，确保你不错过任何一个热点。',
  },
  {
    q: '如何投稿爆料内容？',
    a: '欢迎通过页面底部的投稿爆料入口提交你掌握的独家内幕和一手爆料。我们会对所有投稿进行严格审核，确保信息真实准确后再发布。优质爆料投稿者将获得平台推荐位曝光机会。',
  },
  {
    q: '黑料视频可以下载观看吗？',
    a: '五一黑料网提供的黑料视频合集支持在线观看。所有视频内容均来自公开平台，我们仅做聚合展示，不提供下载服务。如需获取原始视频，可直接前往来源平台查看。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '五一黑料网采用实时更新机制，编辑团队全天候监控全网热点。重大爆料事件发生后5分钟内即可完成内容上线，常规热点瓜每30分钟滚动刷新一次，确保你看到的是最新最热的黑料动态。',
  },
];

export default function SectionFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            吃瓜常见问答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于五一黑料网，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-base md:text-lg font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <span className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIdx === idx ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}